import { render, staticRenderFns } from "./PrivateChatModal.vue?vue&type=template&id=2c949dba&scoped=true"
import script from "./PrivateChatModal.vue?vue&type=script&lang=js"
export * from "./PrivateChatModal.vue?vue&type=script&lang=js"
import style0 from "./PrivateChatModal.vue?vue&type=style&index=0&id=2c949dba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c949dba",
  null
  
)

export default component.exports